import { render, staticRenderFns } from "./ConfigFieldDangers.vue?vue&type=template&id=59bf0034&scoped=true"
import script from "./ConfigFieldDangers.vue?vue&type=script&lang=js"
export * from "./ConfigFieldDangers.vue?vue&type=script&lang=js"
import style0 from "./ConfigFieldDangers.vue?vue&type=style&index=0&id=59bf0034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf0034",
  null
  
)

export default component.exports